

/*========================================================================================================================================================
  #                                                                 GLOBAL FUNCTIONS
==========================================================================================================================================================*/
const currentUrl = window.location.href;

function sayHello(){
  return console.log("hello")
}
function isProductPage(){
  return currentUrl.includes("/products/")
}
function isWishlistPage(){
  return currentUrl.includes("/wishlist")
}
function isCollectionPage(){
  return currentUrl.includes("/collections/")
}
function isSearchPage(){
  return currentUrl.includes("/search")
}
function isCartPage(){
  return currentUrl.includes("/cart")
}
function isContactPage(){
  return currentUrl.includes("/contacta")
}


// // --------- DO something every change of url, in case the collection filter is used. ---------
// function isCollectionPageFilterClicked(myCallback){
//   if(isCollectionPage()){
//     let previousUrl = "";
//     const observer = new MutationObserver(function (mutations) {
//       if (window.location.href !== previousUrl) {
//         previousUrl = window.location.href;
//         setTimeout(() => {
//           myCallback()
//         }, 200);
//       }
//     });
//     const myConfig = { subtree: true, childList: true };
//     observer.observe(document, myConfig);     
//   }
// }

// // --------- DO something  when in collection page more products are loaded ---------
// function doItWhenProductListGrows(callback) {
//     function handleChildCountChange(mutationsList, observer) {
//         for(let mutation of mutationsList) {
//             if (mutation.type === 'childList') {      
//                 let numberOfChildren = mutation.target.children.length;
//                 // console.log('Number of children changed to:', numberOfChildren);
//                 callback();
//             }
//         }
//     }
//     let targetNode = document.querySelector('.m-collection-products');
//     let config = { childList: true };
//     let observer = new MutationObserver(handleChildCountChange);
//     if (targetNode) {
//         observer.observe(targetNode, config);
//     } 
// }
 
// // --------- DO something when the section has loaded, pass the section as param to the cb ---------
// function waitForSectionToBeLoaded(target, callback) {
//   const outerObserver = new MutationObserver((mutationsList, observer) => {
//     const targetElement = document.querySelector(target);
//     if (targetElement) {
//       observer.disconnect(); 
//       callback(targetElement);
//     }
//   });
//   outerObserver.observe(document.documentElement, { childList: true, subtree: true });
// }

// // --------- DO something when the section has loaded , 2 nested target, empty cb param---------
// function waitForSectionToBeLoaded2(parent, target, callback) {
//   const outerObserver = new MutationObserver((mutationsList, observer) => {
//     const parentElement = document.querySelector(parent);
//     const targetElement = parentElement.querySelector(target);
//     if (targetElement) {
//       observer.disconnect(); 
//       callback();
//     }
//   });
//   outerObserver.observe(document.documentElement, { childList: true, subtree: true }); 
// }



/*========================================================================================================================================================
  #                                                                 CART DISCOUNTS
==========================================================================================================================================================*/

//const checkDiscounts = () => {
//  fetch('/cart.js')
//    .then(response => response.json())
//    .then(data => {
//      console.log('Items en el carrito:', data.items);
//    })
//    .catch(error => {
//      console.error('Error al obtener los datos del carrito:', error);
//    });
//}

//document.addEventListener('DOMContentLoaded', function() {
//    let cartBtns = document.querySelectorAll('a[href*="/cart"]');

//    if (cartBtns) {
//      cartBtns.forEach(cartBtn => {
//        cartBtn.addEventListener('click', () => {
//          console.log('se accede al carrito');
//          checkDiscounts();
//        })
//      })
//    }
//});


/*========================================================================================================================================================
  #                                                                 XXX
==========================================================================================================================================================*/
